import React from "react";
import "./ComplaintInput.scss";
import bannerRight from '../../../assets/images/Stripes Dark Top Right Small.svg';

function ComplaintInput() {
    return (
        <>
            <div className={'complaint-parent'}>
                <section className={'feedbackSection'}>
                    <div className={'contentWrapper'}>
                        <div className={'textContainer'}>
                            <h2 className={'complaint-heading'}>Complaints or feedback</h2>
                            <p className={'complaintInfoDescription'}>
                                We're always looking for ways to improve our service, and your
                                feedback is invaluable to us. Whether you have a suggestion for how
                                we can do better or you need to make a complaint, we're here to
                                listen and support you.
                            </p>
                        </div>
                    </div>
                </section>
                <div className='banner-right-img'>
                    <img src={bannerRight} className="banner-right-img" alt='Banner Right'/>
                </div>
            </div>
        </>
    );
}

export default ComplaintInput;
